export default "__VITE_ASSET__C9kMYr$N__"